import { useSelector } from "react-redux";
import { useInfiniteQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

const PAGE_SIZE = 20;

// Mirrors useGetChannelMessages — the backend deliberately keeps the
// two endpoint shapes identical so the same infinite-query plumbing
// (page+1, hasNext, reversed flatten) works for both.
export const useGetDmMessages = (partnerStaffId) => {

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useInfiniteQuery({
    queryKey: ["chatDm", tenantVal, partnerStaffId],
    queryFn: async ({ pageParam = 0 }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/chat/dm/${partnerStaffId}/messages`,
        { params: { page: pageParam, size: PAGE_SIZE } }
      );

      const data = response.data;

      if (data && typeof data === "object" && Array.isArray(data.messages)) {
        return data;
      }

      return {
        messages: Array.isArray(data) ? data : [],
        page: 0,
        size: PAGE_SIZE,
        totalElements: Array.isArray(data) ? data.length : 0,
        totalPages: 1,
        hasNext: false,
        hasPrevious: false,
      };
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage) =>
      lastPage.hasNext ? lastPage.page + 1 : undefined,
    refetchInterval: 30000,
    enabled: !!tenantVal && !!partnerStaffId,
    meta: { errorMessage: "Error fetching direct messages" },
  });
};
